import { ThunkAction } from 'redux-thunk'
import { loadProfile } from '.'
import { RootState } from '..'
import { transactionApi } from '../../apis'
import { TransactionEntity, TransactionFilter } from '../../models'
import store from '../index'
import {
  SET_SELECTED_TRANSACTION,
  SET_TOTAL_AMOUNT_OF_TRANSACTIONS,
  SET_TOTAL_TRANSACTIONS,
  SET_TOTAL_VOLUME_OF_TRANSACTIONS,
  SET_TRANSACTIONS,
  SET_TRANSACTIONS_LOADED,
  SET_TRANSACTION_FILTER,
  TransactionAction,
} from '../types'

export const setTransactions = (
  transactions: TransactionEntity[]
): TransactionAction => ({
  type: SET_TRANSACTIONS,
  payload: transactions,
})

export const setTransactionsLoaded = (loaded: boolean): TransactionAction => ({
  type: SET_TRANSACTIONS_LOADED,
  payload: loaded,
})

export const setTotalTransactions = (
  totalTransactions: number
): TransactionAction => ({
  type: SET_TOTAL_TRANSACTIONS,
  payload: totalTransactions,
})

export const setTotalAmountOfTransactions = (
  totalAmountOfTransactions: number
): TransactionAction => ({
  type: SET_TOTAL_AMOUNT_OF_TRANSACTIONS,
  payload: totalAmountOfTransactions,
})

export const setTotalVolumeOfTransactions = (
  totalVolumeOfTransactions: number
): TransactionAction => ({
  type: SET_TOTAL_VOLUME_OF_TRANSACTIONS,
  payload: totalVolumeOfTransactions,
})

export const loadTransactions = (): ThunkAction<
  void,
  RootState,
  null,
  TransactionAction
> => {
  return async (dispatch) => {
    try {
      const resp = await transactionApi.getTransactions(
        store.getState().transaction.transactionFilter
      )
      dispatch({
        type: SET_TRANSACTIONS,
        payload: resp.data.data,
      })
      dispatch(setTotalTransactions(resp.data.totalElement))
      dispatch(setTotalAmountOfTransactions(resp.data.totalAmount))
      dispatch(setTotalVolumeOfTransactions(resp.data.totalVolume))
    } catch (e) {
      if (e.response && e.response.status && e.response.status === 401) {
        dispatch(loadProfile())
        const resp = await transactionApi.getTransactions(
          store.getState().transaction.transactionFilter
        )
        dispatch({
          type: SET_TRANSACTIONS,
          payload: resp.data.data,
        })
        dispatch(setTotalTransactions(resp.data.totalElement))
        dispatch(setTotalAmountOfTransactions(resp.data.totalAmount))
        dispatch(setTotalVolumeOfTransactions(resp.data.totalVolume))
      }
    } finally {
      dispatch(setTransactionsLoaded(true))
    }
  }
}

export const setSelectedTransaction = (
  transaction: TransactionEntity
): TransactionAction => ({
  type: SET_SELECTED_TRANSACTION,
  payload: transaction,
})

export const setTransactionFilter = (
  filter: TransactionFilter
): TransactionAction => {
  return {
    type: SET_TRANSACTION_FILTER,
    payload: filter,
  }
}
